type NavGuardStatus = {
  key: string
  message: string | undefined
  preventPageLeave: boolean
  preventRouteLeave: boolean
  ignoreQuery: boolean
}

export default defineNuxtPlugin(() => {
  const state = useState<NavGuardStatus[]>('navGuard', () => [])
  const router = useRouter()
  const { $dialog } = useNuxtApp()

  const preventLeave = ({
    key = 'root',
    preventPageLeave = true,
    preventRouteLeave = true,
    ignoreQuery = true,
    message = undefined,
  }: {
    key?: string
    preventPageLeave?: boolean
    preventRouteLeave?: boolean
    ignoreQuery?: boolean
    message?: string
  } = {}) => {
    state.value.push({
      key,
      message,
      preventPageLeave,
      preventRouteLeave,
      ignoreQuery,
    })
  }
  const allowLeave = (key: string = 'root') => {
    state.value = state.value.filter((item) => item.key !== key)
  }

  useEventListener('beforeunload', (e) => {
    if (state.value.every((item) => !item.preventPageLeave)) {
      return
    }
    e.preventDefault()
    e.returnValue = ''
  })

  router.beforeEach(async (to, from) => {
    if (
      state.value.every(
        (item) =>
          // preventRouteLeaveがfalseの場合は遷移可能
          !item.preventRouteLeave ||
          // ignoreQueryがtrueのとき、routeが不変であれば遷移可能
          (item.ignoreQuery && from.path === to.path),
      )
    ) {
      return true
    }

    const result = await $dialog.confirm(
      state.value[state.value.length - 1].message ||
        'ページを離れると現在の編集内容が失われます。ページを離れますか?',
    )

    if (!result) {
      return false
    }

    allowLeave()
  })

  return {
    provide: {
      navGuard: {
        preventLeave,
        allowLeave,
      },
    },
  }
})
